<template>
    <v-card max-width="600" class="mx-auto" elevation="1">
        <v-list-item>
            <v-list-item-avatar tile :size="avatarSize">
                <scorsync-avatar :person="result.athlete" :size="$vuetify.breakpoint.smAndDown ? 'sm' : 'md'" />
                <scorsync-avatar
                    v-if="result.event === 'TS' && result.athlete2"
                    :person="result.athlete2"
                    :size="$vuetify.breakpoint.smAndDown ? 'sm' : 'md'"
                />
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline mb-1 grey--text" :class="{ 'text--darken-3': !$vuetify.theme.dark }">
                    <div v-if="result.event === 'TS' && $vuetify.breakpoint.smAndUp">
                        {{ result.athlete.name }} & {{ result.athlete2.name }}
                    </div>
                    <div v-else-if="result.event === 'TS' && $vuetify.breakpoint.xsOnly">
                        <div>{{ result.athlete.name }}</div>
                        <div>{{ result.athlete2.name }}</div>
                    </div>
                    <div v-else>{{ result.athlete.name }}</div>
                </v-list-item-title>
                <v-list-item-title class="title mb-2 grey--text" :class="{ 'text--darken-3': !$vuetify.theme.dark }">
                    <div
                        v-if="
                            result.event === 'TS' && result.club_id !== result.club_2_id && $vuetify.breakpoint.smAndUp
                        "
                    >
                        {{ result.club.name }} & {{ result.club2.name }}
                    </div>
                    <div
                        v-else-if="
                            result.event === 'TS' && result.club_id !== result.club_2_id && $vuetify.breakpoint.xsOnly
                        "
                    >
                        <div>{{ result.club.name }}</div>
                        <div>{{ result.club2.name }}</div>
                    </div>
                    <div v-else>{{ result.club.name }}</div>
                </v-list-item-title>

                <div v-if="get(result, 'latest_score.total')" class="headline">
                    {{ numeral(result.latest_score.total).format('0.000') }}
                </div>

                <trampoline-highlight v-if="result.event === 'TI'" :result="result" />
                <double-mini-highlight v-if="result.event === 'DM'" :result="result" />
                <tumbling-highlight v-if="result.event === 'TU'" :result="result" />
                <synchro-highlight v-if="result.event === 'TS'" :result="result" />
                <all-around-highlight v-if="isAllAround" :result="result" />
            </v-list-item-content>
            <v-list-item-action size="80" color="grey" class="align-self-start">
                <div v-if="result" class="text-h5">{{ result.ordinalRank(`${round}_placement`) }}</div>
            </v-list-item-action>
        </v-list-item>
    </v-card>
</template>

<script>
import numeral from 'numeral';
import get from 'lodash/get';
import ScorsyncAvatar from '@/Components/ScorsyncAvatar.vue';
import Result from '@/Models/Result.js';
import DoubleMiniHighlight from '@/Components/ScoreHighlight/DoubleMiniHighlight.vue';
import TrampolineHighlight from '@/Components/ScoreHighlight/TrampolineHighlight.vue';
import TumblingHighlight from '@/Components/ScoreHighlight/TumblingHighlight.vue';
import SynchroHighlight from '@/Components/ScoreHighlight/SynchroHighlight.vue';
import AllAroundResult from '@/Models/AllAroundResult.js';
import AllAroundHighlight from '@/Components/ScoreHighlight/AllAroundHighlight.vue';

export default {
    name: 'ScoreHighlight',

    components: {
        AllAroundHighlight,
        SynchroHighlight,
        TumblingHighlight,
        TrampolineHighlight,
        DoubleMiniHighlight,
        ScorsyncAvatar,
    },

    props: {
        result: {
            type: [Result, AllAroundResult],
            required: true,
        },

        round: {
            type: String,
            required: true,
        },
    },

    computed: {
        avatarSize() {
            if (this.result.event === 'TS') {
                return this.$vuetify.breakpoint.smAndDown ? 80 : 200;
            }

            return this.$vuetify.breakpoint.smAndDown ? 40 : 150;
        },

        isAllAround() {
            return this.result instanceof AllAroundResult;
        },
    },

    methods: {
        numeral,
        get,
    },
};
</script>

<style lang="scss" scoped>
.v-list-item__avatar {
    display: block;
}
</style>
